import EmailInfo from '../events/models/mail-info'

export default class OfficeApiInfoState {
  isGraphApiAvailable: boolean = false
  isEwsApiAvailable: boolean = true
  bcc: Office.EmailAddressDetails[] = []
  sentDate: Date | null = null
  conversationId: string = ''
  conversationIndex: string = ''
  internetMessageId: string = ''

  resetState() {
    this.bcc = []
    this.sentDate = null
    this.conversationId = ''
    this.conversationIndex = ''
    this.internetMessageId = ''
  }

  updateMailInfo(apiInfo: EmailInfo) {
    this.bcc = apiInfo.bcc as Office.EmailAddressDetails[]
    this.sentDate = apiInfo.datetime
    this.conversationId = apiInfo.threadId
    this.conversationIndex = apiInfo.threadIndex
    this.internetMessageId = apiInfo.headerMessageId
  }
}
